<template>
  <div>
    <h2>{{message}}</h2>
  </div>
</template>

<script>
import { authenticate } from "../modules/api";
export default {
  name: "authCallback",
  data() {
    return {
      message: "Logging in..."
    };
  },
  async beforeMount() {
    const tmpToken = this.$route.params.tmpToken;
    // console.log(tmpToken);

    await this.$store.dispatch("exchangeAuthToken", tmpToken);
    this.$router.push("/");
    // let res = await authenticate.exchangeToken(tmpToken);
    // console.log(res.data);
    // this.message = res.data;
  }
};
</script>

<style lang="scss" scoped>

</style>